export const MODULE_SURVEY_FREQUENCY_ANSWERS = [
  { value: "NEVER", label: "Never" },
  { value: "RARELY", label: "Rarely" },
  { value: "SOMETIMES", label: "Sometimes" },
  { value: "OFTEN", label: "Often" },
  { value: "ALWAYS", label: "Always" },
];

export const MODULE_SURVEY_AGREEMENT_ANSWERS = [
  { value: "STRONGLY_DISAGREE", label: "Strongly Disagree" },
  { value: "DISAGREE", label: "Disagree" },
  { value: "NEUTRAL", label: "Neutral" },
  { value: "AGREE", label: "Agree" },
  { value: "STRONGLY_AGREE", label: "Strongly Agree" },
];
